/* eslint-disable no-redeclare */
import { Api } from "../../../../api";
import { useNavigate } from "react-router-dom";
import Table from "../../../../component/common/Table";
import Loader from "../../../../component/common/Loader";
import React, { useEffect, useRef, useState } from "react";
import Topbar from "../../../../container/PulseSurvey/Topbar";
import { CHALLENGE_STATUS } from "../../../../utils/constants";
import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import SearchInput from "../../../../component/common/Input/SearchInput";
import Pagination from "../../../../component/common/Pagination/Pagination";
import {
  errorToast,
  getKeyByValue,
  getPathForSurvey,
  successToast,
  surveyStatusColors,
} from "../../../../utils/helper";
import CommonPopover from "../../../../component/common/popover";

const columns = [
  {
    title: "Title",
    key: "title",
    type: "text",
    align: "left",
    extend: true,
    style: {
      opacity: "opacity-100",
    },
  },
  {
    title: "Description",
    key: "description",
    type: "text2",
    align: "left",
    extend: true,
    style: {
      opacity: "opacity-70",
    },
  },
  {
    title: "Points",
    key: "points",
    type: "text",
    align: "left",
    extend: true,
    style: {
      opacity: "opacity-70",
    },
  },
  {
    title: "Challenge Type",
    key: "content_type",
    type: "text",
    longText: false,
    align: "left",
    extend: true,
    style: {
      opacity: "opacity-100",
    },
  },
  {
    title: "Step Count",
    key: "step_count",
    type: "number",
    extend: true,
    align: "left",
    style: {
      opacity: "opacity-100",
    },
  },
  {
    title: "Status",
    key: "status",
    align: "left",
    type: "text",
    style: {
      opacity: "opacity-100",
    },
  },
  {
    title: "Actions",
    key: "action",
    type: "text",
    align: "left",
    style: {
      opacity: "opacity-100",
    },
  },
];

const contents = [
  { value: 0, label: "Invite Friend" },
  { value: 1, label: "Affirmation" },
  { value: 2, label: "Meditation" },
  { value: 3, label: "Sound" },
  { value: 4, label: "Shoorah Pods" },
  { value: 5, label: "Gratitude" },
  { value: 6, label: "Rituals" },
  { value: 7, label: "Survey" },
  { value: 8, label: "Breathwork" },
  { value: 9, label: "Self Assessment" },
  { value: 10, label: "Tutorial" },
  { value: 11, label: "Peap" },
  { value: 12, label: "Cleanse" },
  { value: 13, label: "Goal" },
];

const ViewAllChallanges = () => {
  const navigate = useNavigate();
  const debounceTimeoutRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [challanges, setChallanges] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [challagesType, setChallangesType] = useState(1);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const { userType } = JSON.parse(localStorage.getItem("userData"));

  const handleFilterOption = (option) => {
    setChallangesType(option);
    setIsFilterOpen(false);
    const query = `page=${currentPage}&limit=10&status=${option}&search=${searchTerm}`;
    fetchChallanges(query);
  };

  const toggleFilter = () => {
    setIsFilterOpen((prev) => !prev);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);

    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    debounceTimeoutRef.current = setTimeout(() => {
      const query = `page=${currentPage}&limit=10&status=${challagesType}&search=${e.target.value}`;
      fetchChallanges(query);
    }, 400);
  };

  const handlePagination = (
    pageNumber,
    pageSize,
    searchKey,
    date,
    query,
    sortBy,
    sortOrder
  ) => {
    setLoader(true);

    if (userType === 0 || userType === 1) {
      var query = "";
      pageNumber && (query = `&page=${pageNumber}`);
      pageSize && (query = `&limit=${pageSize}`);
      searchKey && (query = `&search=${searchKey}`);

      Api.getChallanges(query).then((response) => {
        if (response?.data?.meta?.code === 200) {
          setCurrentPage(pageNumber);
          setChallanges(response?.data?.data || []);
          setTotalCount(response?.data?.meta?.total || 0);
          setLoader(false);
        } else if (response?.code === 401) {
          setLoader(false);
          errorToast(response?.message);
        } else if (response?.data?.meta?.code === 0) {
          setCurrentPage(1);
          setChallanges([]);
          setTotalCount(0);
          setLoader(false);
          errorToast(response?.data?.meta?.message);
        } else {
          setLoader(false);
        }
      });
    }
    if (userType === 3 || userType === 4) {
      var query = "";
      pageNumber && (query = `&page=${pageNumber}`);
      pageSize && (query = `&limit=${pageSize}`);
      searchKey && (query = `&search=${searchKey}`);
      Api.getChallanges(query).then((response) => {
        if (response?.data?.meta?.code === 200) {
          setCurrentPage(pageNumber);
          setChallanges(response?.data?.data || []);
          setTotalCount(response?.data?.meta?.total || 0);
          setLoader(false);
        } else if (response?.code === 401) {
          setLoader(false);
          errorToast(response?.message);
        } else if (response?.data?.meta?.code === 0) {
          setCurrentPage(1);
          setChallanges([]);
          setTotalCount(0);
          setLoader(false);
          errorToast(response?.data?.meta?.message);
        } else {
          setLoader(false);
        }
      });
    }
  };

  const fetchChallanges = (query) => {
    setLoader(true);
    Api.getChallanges(query)
      .then((response) => {
        if (response?.data?.meta?.code === 200) {
          const res = response?.data?.data;
          setChallanges(res);
          setTotalCount(response?.data?.meta?.total || 0);
          setCurrentPage(response?.data?.meta?.page || 0);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
      });
  };

  useEffect(() => {
    const query = `page=1&limit=10&status=1`;
    fetchChallanges(query);
  }, []);

  const tableData = challanges?.map((item) => {
    return {
      title: item?.title,
      description: item?.description,
      points: item?.points + " pts",
      createdBy: item?.createdBy,
      approvedBy: item?.approvalBy,
      content_type: contents?.find(
        (item2) => item2.value === item?.content_type
      )?.label,
      step_count: item?.step_count,
      status: (
        <div
          className={`px-6 py-1 text-xs inline-block rounded-full border text-center ${surveyStatusColors(
            item.status
          )}`}
        >
          {getKeyByValue(CHALLENGE_STATUS, item.status)}
        </div>
      ),
      action: (
        <CommonPopover
          label={<EllipsisVerticalIcon className="w-5 h-5" />}
          className={"!p-0 bg-transparent border-none shadow-none rounded-none"}
          contentClassName={"max-w-[164px] "}
        >
          {
            <ul className="text-shoorah-lightBlack">
              <li>
                <button
                  onClick={() => {
                    navigate(
                      getPathForSurvey(
                        `/team-challanges/add-edit-challenges?id=${item?._id}`
                      )
                    );
                  }}
                  className="flex gap-2 items-start hover:bg-shoorah-primary/10 px-6 py-2 w-full"
                >
                  Edit
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleDelete(item?._id)}
                  className="flex gap-2 items-start hover:bg-shoorah-primary/10 px-6 py-2 w-full"
                >
                  Delete
                </button>
              </li>
            </ul>
          }
        </CommonPopover>
      ),
    };
  });

  const handleDelete = async (id) => {
    setLoader(true);
    const res = await Api.deleteChallange(id);
    if (res?.data?.meta?.code === 200) {
      successToast(res?.data?.meta?.message);
      const query = `page=${currentPage}&limit=10&status=${challagesType}&search=${searchTerm}`;
      fetchChallanges(query);
    } else {
      setLoader(false);
    }
  };

  return (
    <div className="mx-auto max-w-[1640px] lg:pl-5">
      {loader && <Loader />}
      <Topbar title={"All Challenges"} />
      <div className="flex flex-wrap items-center sm:justify-between gap-4 justify-center lg:mt-10 sm:mb-4">
        <div className="flex flex-col sm:flex-row items-center w-full sm:w-auto">
          <div className="w-full sm:w-auto">
            <SearchInput
              id="searchKey"
              name="searchKey"
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Search Challenges"
              className="w-full max-w-md border rounded-md p-2"
            />
          </div>
        </div>
        <div className="flex flex-wrap sm:justify-end w-full sm:w-auto">
          <div className="relative inline-block text-left mb-4 sm:mb-0 mr-3">
            <button
              type="button"
              onClick={toggleFilter}
              className="inline-flex justify-between items-center w-full px-3 py-[7px] sm:text-sm text-[12px] font-medium text-gray-700 border dark:border-text-shoorah-darkBg border-[#0B1D2E] sm:rounded-[100px] rounded-[80px] dark:text-shoorah-darkBg dark:border-shoorah-darkBg"
            >
              {challagesType === 0
                ? "Draft"
                : challagesType === 1
                ? "Active"
                : challagesType === 2
                ? "Send for Approval"
                : challagesType === 3
                ? "Rejected"
                : "Deleted"}
              <svg
                className={`transform transition-transform ml-0 sm:ml-3 dark:invert ${
                  isFilterOpen ? "rotate-180" : "rotate-0"
                }`}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.28 9.9668L12.9333 14.3135C12.42 14.8268 11.58 14.8268 11.0666 14.3135L6.71997 9.9668"
                  stroke="#0B1D2E"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            {isFilterOpen && (
              <div className="absolute left-[-12px] z-10 mt-1 w-[160px] bg-white divide-y divide-gray-100 rounded-md ring-1 ring-[#E7EAE8] ring-opacity-1 dark:bg-shoorah-darkBgColor dark:border-none dark:ring-opacity-0">
                <ul className="py-1 text-sm text-shoorah-lightBlack dark:text-shoorah-darkBg">
                  <li>
                    <button
                      onClick={() => handleFilterOption(0)}
                      className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                    >
                      Draft
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => handleFilterOption(1)}
                      className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                    >
                      Active
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => handleFilterOption(2)}
                      className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                    >
                      Sent for Approval
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => handleFilterOption(3)}
                      className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                    >
                      Rejected
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => handleFilterOption(4)}
                      className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                    >
                      Deleted
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
          <div
            className="flex flex-row relative justify-center items-center w-full sm:w-[170px] sm:p-0 px-4 h-[40px] bg-[#4A57DA] text-[16px] rounded-[100px] text-[#F4F4F4] cursor-pointer"
            onClick={() => setIsOpen(!isOpen)}
          >
            <div className="relative inline-block text-left">
              <button className="flex flex-row items-center" type="button">
                Create New
                <svg
                  className={`transform transtion-transform ml-0 sm:ml-2 ${
                    isOpen ? "rotate-180" : "rotate-0"
                  }`}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.28 9.9668L12.9333 14.3135C12.42 14.8268 11.58 14.8268 11.0666 14.3135L6.71997 9.9668"
                    stroke="#0B1D2E"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="stroke-shoorah-darkBg"
                  />
                </svg>
              </button>

              {isOpen && (
                <div className="absolute -left-20 top-8 z-10 mt-1 w-[220px] bg-white divide-y divide-shoorah-gray1 border-[1.5px] dark:border-none dark:bg-shoorah-darkBgTabColor border-shoorah-gray1 rounded-lg">
                  <ul className="py-[14px] text-[16px] font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg w-full">
                    <li>
                      <button
                        onClick={() =>
                          navigate(
                            getPathForSurvey(
                              "/team-challanges/add-edit-challenges"
                            )
                          )
                        }
                        className="block px-5 py-2 w-full text-left hover:bg-gray-100 dark:hover:bg-shoorah-darkBgColor"
                      >
                        New Challenge
                      </button>
                    </li>
                    <li className="w-[calc(100%-40px)] h-[1px] bg-shoorah-gray1 mx-auto my-1"></li>
                    <li>
                      <button
                        onClick={() =>
                          navigate(
                            getPathForSurvey(
                              "/team-challanges/add-edit-rewards?tab=1"
                            )
                          )
                        }
                        className="block px-5 py-2 w-full text-left hover:bg-gray-100 dark:hover:bg-shoorah-darkBgColor"
                      >
                        New Shoorah Reward
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="space-y-6 pb-16 mt-4">
        <Table columns={columns} data={tableData} name={"challanges"} />
        <Pagination
          currentPage={currentPage}
          totalCount={totalCount}
          pageSize={10}
          disabled={challanges?.length === 0}
          onPageChange={(page) => handlePagination(page, 10, searchTerm)}
        />
      </div>
    </div>
  );
};

export default ViewAllChallanges;
